import { render, staticRenderFns } from "./TherapyService.vue?vue&type=template&id=cfd337b0&scoped=true&"
import script from "./TherapyService.vue?vue&type=script&lang=js&"
export * from "./TherapyService.vue?vue&type=script&lang=js&"
import style0 from "./TherapyService.vue?vue&type=style&index=0&id=cfd337b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd337b0",
  null
  
)

export default component.exports